import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const GRUPPI = [["clienti", "Clienti"], ["pratiche", "Pratiche"], ["prodotti", "Prodotti"]];

export const GlobalSearch = ({ className = "" }) => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const box = useRef(null);
  const nav = useNavigate();

  useEffect(() => {
    if (q.trim().length < 2) { setRes(null); setBusy(false); return undefined; }
    let vivo = true;
    setBusy(true);
    const t = setTimeout(() => {
      api.get("/hub/cerca-tutto", { params: { q } })
        .then(({ data }) => { if (vivo) setRes(data); })
        .catch(() => { if (vivo) setRes({ clienti: [], pratiche: [], prodotti: [] }); })
        .finally(() => { if (vivo) setBusy(false); });
    }, 250);
    return () => { vivo = false; clearTimeout(t); setBusy(false); };
  }, [q]);

  useEffect(() => {
    const off = (e) => { if (box.current && !box.current.contains(e.target)) setRes(null); };
    document.addEventListener("mousedown", off);
    return () => document.removeEventListener("mousedown", off);
  }, []);

  const tutti = res ? GRUPPI.flatMap(([k]) => res[k] || []) : [];
  const apri = (r) => { setRes(null); setQ(""); nav(r.link); };

  return (
    <div ref={box} className={`relative ${className}`}>
      <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
      <input data-testid="shell-search-input" value={q} onChange={(e) => setQ(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" && tutti[0]) apri(tutti[0]); if (e.key === "Escape") setRes(null); }}
        placeholder="Cerca cliente, pratica o prodotto…" aria-label="Cerca cliente, pratica o prodotto"
        className="w-full h-10 pl-10 pr-9 rounded-lg bg-sage border border-transparent text-sm outline-none focus:bg-white focus:border-navy focus:ring-2 focus:ring-navy/15 transition-colors" />
      {busy && <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-slate-400" />}
      {res && (
        <div className="absolute z-50 mt-2 w-full rounded-2xl bg-white border border-border shadow-xl overflow-hidden max-h-[70vh] overflow-y-auto" data-testid="shell-search-results">
          {tutti.length === 0 && <p className="px-4 py-3 text-sm text-slate-500" data-testid="shell-search-empty">Nessun risultato per “{q}”. Prova con il nome, la partita IVA o il numero di pratica.</p>}
          {GRUPPI.filter(([k]) => (res[k] || []).length).map(([k, label]) => (
            <div key={k} className="py-1 border-b border-border last:border-0">
              <p className="px-4 pt-2 pb-1 text-[11px] uppercase tracking-wider font-semibold text-navy">{label}</p>
              {res[k].map((r) => (
                <button key={`${k}-${r.id}`} onClick={() => apri(r)} data-testid={`shell-search-${k}-${r.id}`}
                  className={`w-full text-left px-4 py-2 hover:bg-sage transition-colors ${r === tutti[0] ? "bg-sage/60" : ""}`}>
                  <span className="block text-sm font-medium text-slate-800 truncate">{r.titolo}</span>
                  {r.sotto && <span className="block text-xs text-slate-500 truncate">{r.sotto}</span>}
                </button>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
